import { CSSProperties } from "react";
import { fontFamily } from "@clockwise/web-commons/src/styles/type.styles";

// ~-~-~-~-~-~-~-~-~-~-~-
// ChromeFeed
// ~-~-~-~-~-~-~-~-~-~-~-
export const content: CSSProperties = {
  zIndex: 1,
  position: "relative",
  paddingBottom: 102, // offset for fixed button
  height: "inherit",
};

export const background: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 0,
};

export const emptyContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  textAlign: "center",
  height: "inherit",
  paddingBottom: 100,
};

export const emptyText: CSSProperties = {
  margin: "30px 10px 15px",
  fontFamily,
  fontSize: 14,
  lineHeight: "17px",
};
